const l = "__mixwith_appliedMixin", u = "__mixwith_wrappedMixin", O = "__mixwith_cachedApplications", y = "__mixwith_instanceOf", j = (t, e) => {
  const s = e(t);
  return s.prototype[l] = b(e), s;
}, A = (t, e) => Object.hasOwn(t, l) && t[l] === b(e), v = (t, e) => {
  for (; t != null; ) {
    if (A(t, e)) return !0;
    t = Object.getPrototypeOf(t);
  }
  return !1;
}, h = (t, e) => (Object.setPrototypeOf(e, t), t[u] || (t[u] = t), e), b = (t) => t[u] || t, P = (t) => h(t, (e) => {
  let s = e[O];
  s || (s = e[O] = /* @__PURE__ */ new Map());
  let i = s.get(t);
  return i || (i = t(e), s.set(t, i)), i;
}), g = (t) => h(t, (s) => v(s.prototype, t) ? s : t(s)), B = (t) => (t[y] || (t[y] = !0, Object.defineProperty(t, Symbol.hasInstance, {
  value(e) {
    return v(e, t);
  }
})), t), D = (t) => h(t, (e) => j(e, t)), a = (t) => g(P(D(B(t)))), W = (t) => new I(t);
class I {
  constructor(e) {
    this.superclass = e;
  }
  /**
   * Applies a chain of mixins to a base class. The method supports up to six mixins.
   * The mixins are applied in reverse sequence (e.g. the right most mixin is applied first, etc.)
   *
   * @param {mixin<Base, A>} a - A mixin to apply.
   * @param {mixin<A, B>} [b] - A mixin to apply (optional).
   * @param {mixin<B, C>} [c] - A mixin to apply (optional).
   * @param {mixin<C, D>} [d] - A mixin to apply (optional).
   * @param {mixin<D, E>} [e] - A mixin to apply (optional).
   * @param {mixin<E, F>} [f] - A mixin to apply (optional).
   *
   * @returns {Base & A & B & C & D & E & F} - A new class constructor that includes the functionalities
   *                                           of all mixins and the base class.
   */
  with(e, s, i, _, d, f) {
    var M;
    this.superclass = (M = this.superclass) != null ? M : class {
    };
    const n = a(e), c = s ? a(s) : void 0, r = i ? a(i) : void 0, o = _ ? a(_) : void 0, p = d ? a(d) : void 0, w = f ? a(f) : void 0;
    return w && p && o && r && c && n ? w(p(o(r(c(n(this.superclass)))))) : p && o && r && c && n ? p(o(r(c(n(this.superclass))))) : o && r && c && n ? o(r(c(n(this.superclass)))) : r && c && n ? r(c(n(this.superclass))) : c && n ? c(n(this.superclass)) : n(this.superclass);
  }
}
export {
  W as m
};
